import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import {
  FolderDocumentContains,
  FolderDocumentUpdate,
  uploadDocFile,
} from "./DocumentService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";

import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { ProgressBar } from "primereact/progressbar";

const BulkUploadDocuments = () => {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [isLoading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { Id } = useParams();
  const [multipleFiles, setMultipleFiles] = useState([]);
  const stepperRef = useRef(null);

  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const [folderData, setFolderData] = useState({});
  const [selectedRetryFile, setSelectedRetryFile] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [uploadFilesMessage, setUploadFilesMessage] = useState("");
  const [uploadTypeMessage, setUploadTypeMessage] = useState("");
  const [RecentUploadMessage, setRecentUploadMessage] = useState("");
  const [RecentUploadsActivityMessage, setRecentUploadsActivityMessage] =
    useState("");
  const [DocumentInvalidMessage, setDocumentInvalidMessage] = useState("");
  const [DocumentProgressMessage, setDocumentProgressMessage] = useState("");

  const [DocumentReuploadMessage, setDocumentReuploadMessage] = useState("");

  const [DragDropHeading, setDragDropHeading] = useState("");
  const [FileCheckHeading, setFileCheckHeading] = useState("");
  const [BulkUploadHeading, setBulkUploadHeading] = useState("");

  const [UploadFilesHeading, setUploadFilesHeading] = useState("");
  const restrictedExtensions = [
    "exe",
    "bat",
    "cmd",
    "sh",
    "msi",
    "dll",
    "js",
    "php",
    "py",
    "jar",
  ];
  const [FolderId, setFolderId] = useState(0);

  useEffect(() => {
    GetFolderDataByGUID(Id);
    GetMasterSystemAlertList();
  }, []);

  async function GetFolderDataByGUID(folderId) {
    const params = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: 0, // Number(FolderId),
      Search: "",
      Id: 0,
      GUID: folderId,
      BookMarkedOnly: 0,
    };
    try {
      const responseData = await FolderDocumentContains(params);
      const data = responseData?.Data;
sessionStorage.setItem("reload", true);
      setFolderId(data[0]?.Id);
    } catch {}
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == "Upload_File") {
        setUploadFilesMessage(msg?.Desc);
      }
      if (msg?.Name == "Upload_Type") {
        setUploadTypeMessage(msg?.Desc);
      }
      if (msg?.Name == "Recent_Uploads") {
        setRecentUploadMessage(msg?.Desc);
      }
      if (msg?.Name == "Recent_UploadsActivity") {
        setRecentUploadsActivityMessage(msg?.Desc);
      }
      if (msg?.Name == "Document_Invalid") {
        setDocumentInvalidMessage(msg?.Desc);
      }
      if (msg?.Name == "Document_Progress") {
        setDocumentProgressMessage(msg?.Desc);
      }
      if (msg?.Name == "Document_ReUpload") {
        setDocumentReuploadMessage(msg?.Desc);
      }

      if (msg?.Name == "Drag_Drop_Heading") {
        setDragDropHeading(msg?.Desc);
      }
      if (msg?.Name == "Files_Check_Heading") {
        setFileCheckHeading(msg?.Desc);
      }
      if (msg?.Name == "Bulk_Upload_Heading") {
        setBulkUploadHeading(msg?.Desc);
      }
      if (msg?.Name == "Upload_Files_Heading") {
        setUploadFilesHeading(msg?.Desc);
      }
    });
  }, []);

  const handleFileChangeDoc = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      const extension = file.name.split(".").pop().toLowerCase();

      if (restrictedExtensions.includes(extension)) {
        invalidFiles.push(file.name);
      } else {
        validFiles.push({
          file,
          progress: 0,
          apiResponse: "pending",
          dropFileValue: 0,
        });
      }
    });

    // If any invalid files found
    if (invalidFiles.length > 0) {
      toster.current.error(
        `These file types are not allowed:\n${invalidFiles.join("\n")}`,
      );
    }

    // Reset input if needed
    event.target.value = "";

    // Set only valid files
    if (validFiles.length > 0) {
      setMultipleFiles(validFiles);
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = async (e, value) => {
    e.preventDefault();
    setIsDragging(false);
    const items = e.dataTransfer.items;
    const allFiles = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        const files = await traverseFileTree(entry);
        // allFiles.push(...files);
        allFiles.push(files);

        // for (let f of allFiles) {
        await processDragDrop(files, FolderId ? FolderId : 0, 0, false, value);
        // }
      }
      // toster.current.success("Files uploaded successfully");
    }
  };

  function traverseFileTree(item, path = "") {
    return new Promise((resolve) => {
      if (item.isFile) {
        const extension = item.name.split(".").pop().toLowerCase();

        if (restrictedExtensions.includes(extension)) {
          toster.current.error(
            `These file types are not allowed:\n${item.name}`,
          );
        } else {
          item.file((file) => {
            resolve({
              name: file.name,
              type: "file",
              file,
            });
          });
        }
      } else if (item.isDirectory) {
        const dirReader = item.createReader();

        dirReader.readEntries(async (entries) => {
          let results = [];
          for (let entry of entries) {
            const nestedFiles = await traverseFileTree(entry);

            results.push(nestedFiles);
          }

          resolve({
            name: item.name,
            type: "directory",
            DocTypeId: 101,
            results,
          });
        });
      }
    });
  }

  async function uploadFolderDocFile(file, folderId, isOverride) {
    setIsloading(true);

    if (file) {
      const formData = new FormData();
      formData.append("files", file.file);

      let params = {
        UploadType: UploadFile_KEYS?.Document,
        RefId: 0,
      };

      try {
        const response = await uploadDocFile(params, formData);

        const docPathURL = response?.Data;

        const docPath = docPathURL[0];
        const fileName = docPath.split(/[/\\]/).pop();
        const ext = fileName.split(".").pop();
        let docTypeId = 0;
        if (["jpeg", "jpg", "png"].includes(ext)) docTypeId = 106;
        else if (ext === "pdf") docTypeId = 102;
        else if (["xls", "xlsx", "csv"].includes(ext)) docTypeId = 103;
        else if (["doc", "docx"].includes(ext)) docTypeId = 104;
        else if (["ppt", "pptx"].includes(ext)) docTypeId = 105;
        else if (ext === "mp4") docTypeId = 107;
        else if (ext === "mp3") docTypeId = 108;
        else if (["zip", "rar"].includes(ext)) docTypeId = 109;
        else docTypeId = 110;
        // setIsloading(false);

        return await onDragDropFile({
          folder: {
            docPath: docPath,
            fileName: fileName,
            docTypeId: docTypeId,
          },
          folderId,
          isOverride,
        });
      } catch (error) {
        setIsloading(false);
      } finally {
        setIsloading(false);
      }
    } else {
      setIsloading(false);
    }
    // }
  }

  async function onDragDropFile({
    folder,
    // docPath,
    // fileName,
    // docTypeId,
    folderId,
    isOverride,
    dropFileValue,
  }) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: folder?.docPath,
      Name: folder?.fileName,
      Desc: "",
      DocTypeId: folder?.docTypeId,
      IsOverride: isOverride ? isOverride : 0,
    };

    try {
      setMultipleFiles((prev) => {
        const copy = [...prev];

        copy.map((file) => {
          if (file?.file?.name === params?.Name) {
            file.apiResponse = "uploading";
          }
        });

        return copy;
      });

      const response = await FolderDocumentUpdate(params);
      if (response?.StatusCode === 2000 && dropFileValue === 1) {
         toster.current.success("Files uploaded successfully.")
        redirectToDocumentList();
       
      } else {
        return {
          name: response?.Data?.Name || params?.Name,
          DocPath: params?.DocPath,
          DocTypeId: params?.DocTypeId,
          progress: response?.StatusCode === 2000 ? "100" : "0",
          apiResponse: response?.StatusCode === 2000 ? "Success" : "Retry",
        };
      }
    } catch (error) {
      // setIsloading(false);
      return {
        name: params?.Name,
        DocPath: params?.DocPath,
        DocTypeId: params?.DocTypeId,
        progress: "0",
        apiResponse: "Failed",
      };
    }
  }

  async function onDragDropFolder(folder, folderId, dropFolderValue) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: "",
      Name: folder.name,
      Desc: "",
      DocTypeId: folder.DocTypeId,
      IsOverride: folder.IsOverride || 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000 && dropFolderValue === 1) {
        setErrorMessage("");
        setFolderData({});
        toster.current.success("Folder uploaded successfully.");
        redirectToDocumentList();
      }
    

      return response;
    } catch (error) {
      // toster.current.error(ERROR_LIST.PostFolder);
    }
  }

  async function processDragDrop(
    folder,
    folderId,
    override = 0,
    isRootOverride = false,
    value,
  ) {
    const uploadedFiles = [];
    if (folder.type === "file") {
      const response = await uploadFolderDocFile(folder, folderId, override);

      if (response?.apiResponse === "Success" && value === 1) {
           toster.current.success("Files uploaded successfully.");
        redirectToDocumentList();
     
      } else if (response?.apiResponse === "Retry" && value === 1) {
        setSelectedRetryFile({
          DocTypeId: response?.DocTypeId,
          DocPath: response?.DocPath,
          name: response?.name,
          dropFileValue: 1,
        });
        setErrorMessage(
          "A document with the same name already exists in this folder.",
        );
        setFolderData({ folder: folder, folderId: folderId });
        const modalEl = document.getElementById("uploadFileErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    }

    if (folder.type === "directory") {
      const response = await onDragDropFolder(
        { ...folder, IsOverride: override },
        folderId,
        value,
      );

      if (response?.StatusCode === 2000) {
        for (const child of folder.results) {
          await processDragDrop(child, response?.Data?.Id, 0, false, value);
        }

        if (isRootOverride) {
          override = 0;
        }
      } else if (response?.StatusCode === 2003 && value === 1) {
        setSelectedRetryFile({
          DocTypeId: folder?.DocTypeId,
          DocPath: folder?.DocPath,
          name: folder?.Name,
        });
        setErrorMessage(response?.Message);
        setFolderData({ folder: folder, folderId: folderId });
        const modalEl = document.getElementById("dragDropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      // uploadedFiles.push({
      //   ...response,
      // });

      // setMultipleFiles(uploadedFiles);
    }
  }

  async function uploadMultipleDocuments(isOverride) {
    const uploadedFiles = [];
    if (multipleFiles.length > 0) {
      for (let i = 0; i < multipleFiles.length; i++) {
        const response = await uploadFolderDocFile(
          multipleFiles[i],
          FolderId,
          isOverride,
        );

        uploadedFiles.push({
          ...response,
        });
      }

      setMultipleFiles(uploadedFiles);
    }
  }

  const redirectToDocumentList = () => {
    sessionStorage.setItem("reload", true);
    if (Id) {
      history.push(`/DocumentList/${Id}`);
    } else {
      history.push("/Documents");
    }
  };

  const retryFilesUpload = (files) => {
    // setMultipleFiles(files);

    setSelectedRetryFile(files);
    setErrorMessage(
      "A document with the same name already exists in this folder.",
    );
    const modalEl = document.getElementById("uploadFileErrorMessagePopup");
    const modal = new window.bootstrap.Modal(modalEl);
    modal.show();
  };

  async function uploadRetryFile(file, isOverride) {
    const docTypeId = file?.DocTypeId;

    const docPath = file?.DocPath;
    const fileName = file?.name;
    const folderId = FolderId;
    const dropFileValue = file?.dropFileValue;

    const response = await onDragDropFile({
      folder: {
        docPath: docPath,
        fileName: fileName,
        docTypeId: docTypeId,
      },
      // docPath,
      // fileName,
      // docTypeId,
      folderId,
      isOverride,
      dropFileValue,
    });

    setMultipleFiles((prev) => {
      const copy = [...prev];

      copy.map((file) => {
        if (file?.name === fileName) {
          file.apiResponse = response?.apiResponse;
          file.progress = response?.progress;
        }
      });

      return copy;
    });
  }

  return (
    <div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row justify-content-center align-item-center">
                <div className="col-lg-9">
                  <div className="Upload-user-profile-bx">
                    <div className="form-head d-flex flex-wrap align-items-center justify-content-between">
                      <div className="me-auto">
                        <h2 className="font-w600 mb-0">
                          {/* Upload in multiple Files */}
                          {UploadFilesHeading}
                        </h2>
                        <p className="mb-0">{uploadFilesMessage}</p>
                      </div>
                    </div>
                    <div className="addnew-assessmentform flex justify-content-center add-assessment-uploadform mt-5">
                      {/* disable-step-click */}
                      <Stepper
                        className=""
                        style={{ flexBasis: "50rem" }}
                        ref={stepperRef}
                      >
                        <StepperPanel>
                          <div className="flex flex-column h-12rem">
                            <div className="Upload-user-profile-bx">
                              <div className="text-center">
                                {multipleFiles?.length === 0 ? (
                                  <>
                                    {/* <h2 className="">Upload Files</h2> */}
                                    <h2 className="">{DragDropHeading}</h2>
                                    <p className="description">
                                      {/* Before you upload your files below, make sure
                                  your file is
                                  <span className="highlight"> correct</span>.
                                  OrgGenie will let you know when your records
                                  are{" "}
                                  <span className="highlight">duplicates</span>{" "}
                                  or<span className="highlight"> invalid</span>. */}
                                      {uploadTypeMessage}
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <h2 className="">
                                      {FileCheckHeading}
                                      {/* Upload Files */}
                                    </h2>
                                    <p className="description">
                                      {/* Before you upload your files below, make sure
                                  your file is
                                  <span className="highlight"> correct</span>.
                                  OrgGenie will let you know when your records
                                  are{" "}
                                  <span className="highlight">duplicates</span>{" "}
                                  or<span className="highlight"> invalid</span>. */}
                                      {DocumentInvalidMessage}
                                    </p>
                                  </>
                                )}
                              </div>
                              <div className="import-section mt-3">
                                {multipleFiles?.length === 0 && (
                                  <h3>Import files</h3>
                                )}
                                <div
                                  // className="upload-box"
                                  className={`upload-box ${
                                    isDragging ? "drag-bulk-active" : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    border: "2px dashed rgb(204, 204, 204)",
                                    padding: "11px",
                                    TextAlign: "center",
                                  }}
                                  onDragEnter={handleDragEnter}
                                  onDragOver={handleDragOver}
                                  onDragLeave={handleDragLeave}
                                  onDrop={(e) => handleDrop(e, 1)}
                                >
                                  {multipleFiles?.length === 0 ? (
                                    <>
                                      <div
                                        className="upload-icon"
                                        style={{ FontSize: "2rem" }}
                                      >
                                        👤
                                      </div>
                                      <p className="mb-0">
                                        Drag and drop or
                                        <span
                                          style={{
                                            color: "blue",
                                            TextDecoration: "underline",
                                          }}
                                        >
                                          {" "}
                                          choose files{" "}
                                        </span>
                                        to upload your Documents.
                                        <br />
                                        All .csv, .xlsx, .pdf, .zip, .jpg and
                                        .rar file types are supported.
                                      </p>
                                      {/* accept=".csv,.xlsx,.xls,.jpeg,.jpg,.png,.mp3,.mp4,.pdf,.doc,.docx.zip,.rar" */}
                                      <input
                                        type="file"
                                        multiple
                                        id="file-upload"
                                        onChange={handleFileChangeDoc}
                                        //  style={{ display: "none" }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <p className="mb-0">
                                        {/* You can upload these{" "}
                                        <span>{multipleFiles?.length}</span>{" "}
                                        selected files and check the uploading
                                        status. If in case, any file has failed
                                        once then you can re-upload the file.
                                        <br />
                                        All .csv, .xlsx, .pdf, .zip, .jpg and
                                        .rar file types are supported. */}
                                        {DocumentProgressMessage}
                                        <br />
                                        {DocumentReuploadMessage}
                                      </p>
                                    </>
                                  )}
                                </div>
                                {multipleFiles?.length > 0 && (
                                  <div class="col-md-12">
                                    <div class="btns-grp mt-5">
                                      <a>
                                        <button
                                          class=" btn btn-dark px-4 py-2"
                                          onClick={redirectToDocumentList}
                                        >
                                          Cancel
                                        </button>
                                      </a>
                                      <button
                                        type="submit"
                                        class="savebutton"
                                        // onClick={uploadMultipleDocuments}
                                        onClick={() => {
                                          stepperRef.current.nextCallback();
                                          uploadMultipleDocuments(0);
                                        }}
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </StepperPanel>
                        <StepperPanel>
                          <div className="flex flex-column h-12rem">
                            <div className="Upload-user-profile-bx">
                              <div className="text-center">
                                <h2 className="">{BulkUploadHeading}</h2>
                                <p className="description">
                                  {/* Before you upload your files below, make sure
                                  your file is
                                  <span className="highlight"> correct</span>.
                                  OrgGenie will let you know when your records
                                  are{" "}
                                  <span className="highlight">duplicates</span>{" "}
                                  or<span className="highlight"> invalid</span>. */}
                                  {RecentUploadMessage} <br />
                                  {RecentUploadsActivityMessage}
                                </p>
                              </div>
                              <div className="import-section mt-3">
                                <table class="table">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">File Name</th>
                                      <th scope="col">Type</th>
                                      {/* <th scope="col">Action</th> */}
                                      <th scope="col">Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {multipleFiles?.map((files, index) => (
                                      <tr key={index}>
                                        <td scope="row">{index + 1}</td>
                                        <td>
                                          {files?.file?.name ?? files?.name}
                                        </td>
                                        <td>
                                          {files?.file?.name?.split(".")[1] ??
                                            files?.name?.split(".")[1]}
                                        </td>
                                        <td>
                                          {files?.apiResponse ===
                                            "uploading" && (
                                            <ProgressBar
                                              mode="indeterminate"
                                              style={{ height: "6px" }}
                                            ></ProgressBar>
                                          )}
                                          {(files?.apiResponse === "Failed" ||
                                            files?.apiResponse === "Retry") && (
                                            <span className="text-danger me-2">
                                              Failed
                                            </span>
                                          )}

                                          {files?.apiResponse === "pending" && (
                                            <span>Pending</span>
                                          )}

                                          {files?.apiResponse === "Success" && (
                                            <ProgressBar
                                              value={files?.progress}
                                              style={{ height: "13px" }}
                                            ></ProgressBar>
                                          )}

                                          {files?.apiResponse === "Retry" && (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              class="bi bi-arrow-clockwise"
                                              viewBox="0 0 16 16"
                                              onClick={() => {
                                                retryFilesUpload(files);
                                              }}
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                                              />
                                              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                                            </svg>
                                          )}

                                          {files?.apiResponse === "Failed" && (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              class="bi bi-arrow-clockwise"
                                              viewBox="0 0 16 16"
                                              onClick={() => {
                                                uploadRetryFile(files, 0);
                                              }}
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                                              />
                                              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                                            </svg>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                    {/* <tr>
                                      <td scope="row">2</td>
                                      <td>Photo gallery</td>
                                      <td>PDF</td>
                                      <td>
                                        <img
                                          src="images/org-img/delete.png"
                                          class="img-fluid w-24"
                                          title="Delete"
                                        />
                                      </td>
                                    </tr>
                                    <tr>
                                      <td scope="row">3</td>
                                      <td>Photo gallery</td>
                                      <td>Video</td>
                                      <td>
                                        <img
                                          src="images/org-img/delete.png"
                                          class="img-fluid w-24"
                                          title="Delete"
                                        />
                                      </td>
                                    </tr> */}
                                  </tbody>
                                </table>

                                <div class="col-md-12">
                                  <div class="btns-grp mt-5">
                                    <a>
                                      <button
                                        class=" btn btn-dark px-4 py-2"
                                        onClick={() => {
                                          stepperRef.current.prevCallback();
                                          setMultipleFiles([]);
                                        }}
                                      >
                                        Back
                                      </button>
                                    </a>
                                    {multipleFiles?.length > 0 && (
                                      <button
                                        type="submit"
                                        class="savebutton"
                                        onClick={redirectToDocumentList}
                                      >
                                        Ok
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </StepperPanel>
                      </Stepper>
                    </div>

                    <div
                      className="modal fade"
                      id="dragDropErrorMessagePopup"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content p-0">
                          <div className="modal-header">
                            <h5 className="modal-title error-alert">
                              Error Alert
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              //   onClick={onCloseErrorPopup}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <p className="error-message">{errorMessage}</p>

                            <div className="text-end">
                              <button
                                type="button"
                                className="savebtn-click btn-purple rounded"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  // setIsOverride(2);
                                  processDragDrop(
                                    folderData.folder,
                                    folderData.folderId,
                                    2,
                                    true,
                                    1,
                                  );
                                }}
                              >
                                Keep Both
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="uploadFileErrorMessagePopup"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content p-0">
                          <div className="modal-header">
                            <h5 className="modal-title error-alert">
                              Error Alert
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              //   onClick={onCloseErrorPopup}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <p className="error-message">{errorMessage}</p>

                            <div className="text-end">
                              <button
                                type="button"
                                className="savebtn-click btn-purple rounded"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  uploadRetryFile(selectedRetryFile, 1);
                                }}
                              >
                                Replace
                              </button>
                              <button
                                type="button"
                                className="savebtn-click btn-purple rounded"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  uploadRetryFile(selectedRetryFile, 2);
                                }}
                              >
                                Keep Both
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default BulkUploadDocuments;
